import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export const getContentTags: QueryFn<[string], { id: string; name: string }[]> = async (client, [_]) => {
  const { data } = await client.get<{ data: { id: string; name: string }[] }>('v1/content-tags', {
    withCredentials: true
  })

  return data.data
}
